'use client';
import { sanitize } from 'isomorphic-dompurify';
import React, { useMemo } from 'react';
import { createExternalLinks } from './createExternalLinks';
export const ContentfulHTML = ({ html, className = '' }) => {
    const innerHtml = useMemo(() => sanitize(html || '', { USE_PROFILES: { html: true } }), [html]);
    return (<div className={className} dangerouslySetInnerHTML={{
            __html: createExternalLinks(innerHtml),
        }}/>);
};
